import React, { useState } from 'react';
// ANTD
import { Button, Modal } from 'antd';
// IMAGE
import ico_gps from 'static/img/downloadGps/ico_gps.png';
import garmin_triangle_icon from 'static/img/downloadGps/garmin_triangle_icon.png';
import kml_icon from 'static/img/downloadGps/kml_icon.png';
import tomtom_logo_icon from 'static/img/downloadGps/tomtom_logo_icon.png';

import { FormattedMessage, useIntl } from 'react-intl';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';

export const dataList = [
  {
    img: ico_gps,
    option: {
      name: 'GPX Route',
      scope: 'tour',
      type: 'gpx',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'GPX Track',
      scope: 'tour',
      type: 'gpx',
      extension: 1,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: garmin_triangle_icon,
    option: {
      name: 'Garmin',
      scope: 'tour',
      type: 'gpx',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: tomtom_logo_icon,
    option: {
      name: 'TomTom',
      scope: 'tour',
      type: 'itn',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'BMW Motorrad Connected',
      scope: 'tour',
      type: 'gpx_bmw_conn',
      extension: 1,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'Honda2019+ 99 points',
      scope: 'tour',
      type: 'gpx_honda_99',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'Triumph',
      scope: 'tour',
      type: 'triumph',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'BoomBox 4.3',
      scope: 'tour',
      type: 'gpx',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: ico_gps,
    option: {
      name: 'BoomBox GTS 6.5',
      scope: 'tour',
      type: 'bbox',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
  {
    img: kml_icon,
    option: {
      name: 'KML',
      scope: 'tour',
      type: 'kml',
      extension: 0,
      reverse: false,
      tourAs: 'route',
    },
  },
];

const MoreOptionView = (props) => {
  const [open, setOpen] = useState(false);
  const [optionData, setOptionData] = useState({});

  return (
    <div className="listGps">
      <div className="moreOptions">
        {!open ? (
          <Button onClick={() => setOpen(true)}>
            <span>
              <FormattedMessage
                id="More download options"
                defaultMessage="More download options"
              />
            </span>
          </Button>
        ) : (
          <Button onClick={() => setOpen(false)}>
            <span>
              <FormattedMessage
                id="Less download options"
                defaultMessage="Less download options"
              />
            </span>
          </Button>
        )}
      </div>
      <div className={open ? 'brandList' : ''}>
        {open
          ? dataList.map((item, i) => (
              <div
                key={i}
                className="optionItem"
                onClick={() => {
                  setOptionData(item.option);
                  props.download(item.option, props);
                }}
              >
                <img src={item.img} />
                <span>{item.option.name}</span>
              </div>
            ))
          : null}
      </div>
    </div>
  );
};

export default MoreOptionView;
